<template>
  <div class="main-panel">
    <div class="nav-bar-operations">
      <img src="@/assets/logogruas.png" alt="HomePage" class="logo-button" />
    </div>

    <header class="header">
      <div class="header__left">
        <div class="avatar" aria-hidden="true">🛡️</div>
        <div class="greet">
          <h1>Administrador</h1>
          <p class="sub">Visor de logs por módulo</p>
        </div>
      </div>
      <div class="header__right">
        <button class="btn btn--ghost" @click="goBack">Volver</button>
      </div>
    </header>

    <section class="grid">
      <article
        v-if="canUnitsOverview"
        class="card"
        role="link"
        tabindex="0"
        @click="go('/panel-unidades')"
        @keyup.enter="go('/panel-unidades')"
      >
        <div class="card__media icon">🚛</div>
        <div class="card__content">
          <div class="card__title">
            <h2>Panel de unidades</h2>
          </div>
          <ul class="card__list">
            <li>Estado de la flota en vivo</li>
            <li>Unidades libres y en servicio</li>
          </ul>
          <div class="card__actions">
            <router-link class="btn btn--primary" to="/panel-unidades">Entrar</router-link>
          </div>
        </div>
      </article>

      <article
        v-if="canOperations"
        class="card"
        role="link"
        tabindex="0"
        @click="go('/logs/operaciones')"
        @keyup.enter="go('/logs/operaciones')"
      >
        <div class="card__media icon">🧰</div>
        <div class="card__content">
          <div class="card__title">
            <h2>Operaciones</h2>
          </div>
          <ul class="card__list">
            <li>Notas de asistencia</li>
            <li>Asignaciones y cambios</li>
          </ul>
          <div class="card__actions">
            <router-link class="btn btn--primary" to="/logs/operaciones">Entrar</router-link>
          </div>
        </div>
      </article>

      <article
        v-if="canAccounting"
        class="card"
        role="link"
        tabindex="0"
        @click="go('/logs/contabilidad')"
        @keyup.enter="go('/logs/contabilidad')"
      >
        <div class="card__media icon">💳</div>
        <div class="card__content">
          <div class="card__title">
            <h2>Contabilidad</h2>
          </div>
          <ul class="card__list">
            <li>Facturas</li>
            <li>Movimientos relacionados</li>
          </ul>
          <div class="card__actions">
            <router-link class="btn btn--primary" to="/logs/contabilidad">Entrar</router-link>
          </div>
        </div>
      </article>

      <article
        v-if="canMaintenance"
        class="card"
        role="link"
        tabindex="0"
        @click="go('/logs/mantenimiento')"
        @keyup.enter="go('/logs/mantenimiento')"
      >
        <div class="card__media icon">🛠️</div>
        <div class="card__content">
          <div class="card__title">
            <h2>Mantenimiento</h2>
          </div>
          <ul class="card__list">
            <li>Órdenes e incidentes</li>
            <li>Unidades</li>
          </ul>
          <div class="card__actions">
            <router-link class="btn btn--primary" to="/logs/mantenimiento">Entrar</router-link>
          </div>
        </div>
      </article>

      <article
        v-if="canRrhh"
        class="card"
        role="link"
        tabindex="0"
        @click="go('/logs/rrhh')"
        @keyup.enter="go('/logs/rrhh')"
      >
        <div class="card__media icon">👥</div>
        <div class="card__content">
          <div class="card__title">
            <h2>RRHH</h2>
          </div>
          <ul class="card__list">
            <li>Empleados</li>
            <li>Comisiones</li>
          </ul>
          <div class="card__actions">
            <router-link class="btn btn--primary" to="/logs/rrhh">Entrar</router-link>
          </div>
        </div>
      </article>

      <article
        v-if="canAccessControl"
        class="card"
        role="link"
        tabindex="0"
        @click="go('/logs/access-control')"
        @keyup.enter="go('/logs/access-control')"
      >
        <div class="card__media icon">🔐</div>
        <div class="card__content">
          <div class="card__title">
            <h2>Permisos</h2>
          </div>
          <ul class="card__list">
            <li>Crear permisos</li>
            <li>Grupos y asignaciones</li>
          </ul>
          <div class="card__actions">
            <router-link class="btn btn--primary" to="/logs/access-control">Entrar</router-link>
          </div>
        </div>
      </article>

      <article
        v-if="canVehicleAccess"
        class="card"
        role="link"
        tabindex="0"
        @click="go('/logs/entradas-y-salidas')"
        @keyup.enter="go('/logs/entradas-y-salidas')"
      >
        <div class="card__media icon">🚧</div>
        <div class="card__content">
          <div class="card__title">
            <h2>Entradas y salidas</h2>
          </div>
          <ul class="card__list">
            <li>Unidades dentro y fuera</li>
            <li>Bitácora de la pluma</li>
          </ul>
          <div class="card__actions">
            <router-link class="btn btn--primary" to="/logs/entradas-y-salidas">Entrar</router-link>
          </div>
        </div>
      </article>

      <article
        v-if="canGateControl"
        class="card"
        role="link"
        tabindex="0"
        @click="go('/logs/pluma')"
        @keyup.enter="go('/logs/pluma')"
      >
        <div class="card__media icon">🛑</div>
        <div class="card__content">
          <div class="card__title">
            <h2>Control de pluma</h2>
          </div>
          <ul class="card__list">
            <li>Abrir y cerrar la pluma</li>
            <li>Historial de comandos</li>
          </ul>
          <div class="card__actions">
            <router-link class="btn btn--primary" to="/logs/pluma">Entrar</router-link>
          </div>
        </div>
      </article>

      <article
        v-if="canItMonitoring"
        class="card"
        role="link"
        tabindex="0"
        @click="go('/it-monitor')"
        @keyup.enter="go('/it-monitor')"
      >
        <div class="card__media icon">🖥️</div>
        <div class="card__content">
          <div class="card__title">
            <h2>Monitor de infraestructura</h2>
          </div>
          <ul class="card__list">
            <li>Servidor, dispositivos y base de datos</li>
            <li>Tiempos de respuesta del API</li>
          </ul>
          <div class="card__actions">
            <router-link class="btn btn--primary" to="/it-monitor">Entrar</router-link>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'LogsVisorMenu',
  data() {
    return {
      permissions: [],
      loading: true,
    }
  },
  created() {
    this.fetchCurrentUser()
  },
  computed: {
    canUnitsOverview() {
      return this.hasPerm('ui_access_units_overview')
    },
    canOperations() {
      return this.hasPerm('ui_access_logs_operations')
    },
    canAccounting() {
      return this.hasPerm('ui_access_logs_accounting')
    },
    canMaintenance() {
      return this.hasPerm('ui_access_logs_maintenance')
    },
    canRrhh() {
      return this.hasPerm('ui_access_logs_rrhh')
    },
    canAccessControl() {
      return this.hasPerm('ui_access_access_control')
    },
    canVehicleAccess() {
      return this.hasPerm('ui_access_logs_vehicle_access')
    },
    canGateControl() {
      return this.hasPerm('ui_access_logs_gate_control')
    },
    canItMonitoring() {
      return this.hasPerm('ui_access_it_monitoring')
    },
  },
  methods: {
    hasPerm(perm) {
      if (!perm) return false
      if (this.permissions.includes(perm)) return true
      return this.permissions.includes(`access_control.${perm}`)
    },
    async fetchCurrentUser() {
      const apiDirectory = process.env.API_DIRECTORY
      this.loading = true
      try {
        const { data } = await axios.get(`${apiDirectory}/current-user/`, {
          headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
        })
        this.permissions = data.permissions || []
        if (!this.hasPerm('ui_access_logs')) {
          this.$router.push({ name: 'MainPanel' })
        }
      } catch (error) {
        this.$router.push({ name: 'MainPanel' })
      } finally {
        this.loading = false
      }
    },
    go(path) {
      this.$router.push(path)
    },
    goBack() {
      this.$router.back()
    },
  },
}
</script>

<style scoped>
.main-panel {
  min-height: 100vh;
  background: #f7f8fb;
  padding: 12vh 24px 48px;
}
.nav-bar-operations {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 10vh;
  background-color: #ffc434;
  z-index: 1000;
  display: flex;
  align-items: center;
  padding-left: 16px;
  box-shadow: 0 2px 0 rgba(0,0,0,.05);
}
.logo-button { height: 55%; object-fit: contain; }
.header { margin-top: 12px; display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.header__left { display: flex; align-items: center; gap: 14px; }
.avatar {
  width: 44px; height: 44px; border-radius: 10px; display: grid; place-items: center;
  background: linear-gradient(135deg, #ffc434, #ffe188);
  color: #3a2a00; font-weight: 800;
}
.greet h1 { font-size: 1.15rem; color: #0f172a; margin: 0; }
.greet .sub { margin: 2px 0 0; color: #667085; font-size: .9rem; }
.header__right { display: flex; gap: 10px; }
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 18px;
  margin-top: 16px;
}
.card {
  background: #fff;
  border: 1px solid rgba(0,0,0,.08);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,.08);
  transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
  outline: none;
  cursor: pointer;
}
.card:hover { transform: translateY(-3px); border-color: rgba(0,0,0,.12); }
.card__media.icon {
  height: 110px; display: grid; place-items: center; font-size: 2rem;
  background: rgba(37,99,235,.07);
}
.card__content { padding: 14px; display: grid; gap: 10px; }
.card__title h2 { font-size: 1rem; margin: 0; color: #000; }
.card__list { margin: 0; padding-left: 16px; color: #444; }
.card__list li { margin: 3px 0; }
.card__actions { display: flex; justify-content: flex-end; }
.btn {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 10px 14px; border-radius: 12px; border: 1px solid transparent;
  background: #151924; color: #fff; cursor: pointer; text-decoration: none;
}
.btn--primary { background: #2563eb; color: #fff; }
.btn--ghost { background: transparent; border: 1px solid rgba(0,0,0,.15); color: #0f172a; }
</style>
